import lazyWithRetry from "../../../utils/lazyWithRetry";
const PromoCodesData = lazyWithRetry(() => import("./PromoCodesData/PromoCodesData"));
const AddPromotion = lazyWithRetry(() => import("./AddPromotion/AddPromotion"));

export { PromoCodesData,AddPromotion };
